import type { Dateable } from 'pkg/api/models/dateable';
import type { Order } from 'pkg/api/models/order';
import type { Record } from 'pkg/api/models/record';

export enum CreditNoteReasonType {
	Other = 'other',
	Chargeback = 'chargeback',
	ReturnedGoods = 'returned-goods',
	ProductUnsatisfactory = 'product-unsatisfactory',
	Overcharged = 'overcharged',
	Duplicate = 'duplicate',
	BillingError = 'billing-error',
	FraudulentCharge = 'fraudulent-charge',
	BadDebt = 'bad-debt',
}

enum CreditNoteType {
	Unknown = 'unknown',
	Refund = 'refund',
	Voided = 'order-voided',
}

export enum CreditNoteRowType {
	Unknown = 'unknown',
	Product = 'product',
	Discount = 'discount',
	Fee = 'fee',
}

export interface CreditNoteRow extends Record, Dateable {
	type: CreditNoteRowType;
	description: string;
	quantity: number;
	amount: number;
	taxPercentage: number;
	taxInclusive: boolean;
	creditNoteId: number;
	productPriceId: number;
	taxRateId: number;
	discountId: number;
}

export interface CreditNote extends Record, Dateable {
	type: CreditNoteType;
	number: string;
	amount: number;
	currency: string;
	issuedAt: number;
	reasonType: CreditNoteReasonType;

	groupId: number;
	orderId: number;
	orderRefundId: number;
	rows: CreditNoteRow[];
	order: Order;
}
